import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { snackBarVisibleVar } from 'context'
import { IModalProps } from 'hooks'
import { useConfirm } from 'material-ui-confirm'
import { useForm } from 'react-hook-form'
import { emailFn } from 'utility/validators'
import { useChangeUserEmailMutation, useCurrentUserQuery } from 'types'

interface IEditEmailForm {
  email: string
}

export const EditEmailDialog = ({ closeModal, modalState }: IModalProps) => {
  const { data: { currentUser } = {} } = useCurrentUserQuery()

  const confirm = useConfirm()

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<IEditEmailForm>({
    mode: 'onTouched',
    defaultValues: {
      email: currentUser?.email
    }
  })

  const [changeUserEmail, { loading }] = useChangeUserEmailMutation({
    onError: (error) =>
      snackBarVisibleVar({
        open: true,
        message: error.message
      }),
    onCompleted: () => closeModal()
  })

  if (!currentUser) {
    return null
  }

  const changeEmailHandler = async ({ email }: IEditEmailForm) => {
    const { confirmed } = await confirm({
      description:
        'Changing the login email signs the member out of any Google/Apple sign-in tied to the ' +
        'old address. Confirm the new address is correct before saving.'
    })

    if (!confirmed) {
      return
    }

    await changeUserEmail({ variables: { userId: currentUser.id, email } })
  }

  return (
    <Dialog open={modalState} onClose={closeModal}>
      <DialogTitle>Change Member Email</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(changeEmailHandler)}>
          <TextField
            label="Email"
            type="email"
            margin="dense"
            fullWidth
            variant="standard"
            error={!!errors.email}
            helperText={errors.email?.message}
            {...register('email', { required: 'This field is required.', validate: emailFn })}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Close</Button>
        <LoadingButton loading={loading} onClick={handleSubmit(changeEmailHandler)}>
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
